import { ObjectTypes } from '@fi-shared/types';

export function getObjectTypeNameTextId(objectType: ObjectTypes, isPlural: boolean = false): string {
    if (objectType === ObjectTypes.User) return !isPlural ? 'user.user' : 'common.users';
    //return !isPlural ? 'colleague' : 'common.colleagues';
    if (objectType === ObjectTypes.Role) return !isPlural ? 'common.role' : 'common.roles';
    if (objectType === ObjectTypes.BusinessUnit) return !isPlural ? 'common.unit' : 'common.units';
    if (objectType === ObjectTypes.Area) return !isPlural ? 'common.area' : 'common.areas';
    if (objectType === ObjectTypes.BusinessArea) return !isPlural ? 'common.business_area' : 'common.business_areas';
    if (objectType === ObjectTypes.Cluster) return !isPlural ? 'common.cluster' : 'common.clusters';
    if (objectType === ObjectTypes.Document) return !isPlural ? 'common.page' : 'common.pages';
    if (objectType === ObjectTypes.Tag) return !isPlural ? 'common.tag' : 'common.tags';
    if (objectType === ObjectTypes.ExtendedRoleRight) return !isPlural ? 'common.item' : 'common.items';
    if (objectType === ObjectTypes.Post) return isPlural ? 'posts' : 'common.post';
    if (objectType === ObjectTypes.NewsFeed) return 'module.news_feed';
    if (objectType === ObjectTypes.MediaBank) return !isPlural ? 'common.file' : 'common.files';
    if (objectType === ObjectTypes.Template) return !isPlural ? 'page_template' : 'templates';
    if (objectType === ObjectTypes.CustomFranchiseIntranetUpgrade) return 'upgrade.upgrades';
    if (objectType === ObjectTypes.SMSMessage) return 'sms_object_name';
    if (objectType === ObjectTypes.Comment) return 'common.comment';
    if (objectType === ObjectTypes.SiteMap) return !isPlural ? 'sitemap.object_name' : 'sitemap.module_name';
    if (objectType === ObjectTypes.Agreement) return !isPlural ? 'common.agreement' : 'common.agreements';
    if (objectType === ObjectTypes.DataFieldGroup) return 'common.data_fields';
    if (objectType === ObjectTypes.Forum) return !isPlural ? 'forum.object_name' : 'forum.object_names';
    if (objectType === ObjectTypes.CheckList) return isPlural ? 'checklist.module_name' : 'common.checklist';
    if (objectType === ObjectTypes.CheckPoint) return 'checklist.names_of_checkpoints';
    if (objectType === ObjectTypes.CheckListTemplate) return isPlural ? 'templates' : 'checklist.checklist_template';
    if (objectType === ObjectTypes.CheckListReport) return 'reports';
    if (objectType === ObjectTypes.ForumPost) return 'common.forum_post';
    if (objectType === ObjectTypes.OtherSettings) return 'common.other_settings';
    if (objectType === ObjectTypes.CustomerSetting) return 'appearance.customer_settings_header';
    if (objectType === ObjectTypes.FirstPage) return 'appearance.startpage_header';
    if (objectType === ObjectTypes.WidgetModuleContent) return 'appearance.sidebar_header';
    if (objectType === ObjectTypes.ListViewSettings) return 'common.listView';
    if (objectType === ObjectTypes.Widget) return 'common.widget';
    if (objectType === ObjectTypes.Statistic2) return !isPlural ? 'common.report' : 'reports';
    if (objectType === ObjectTypes.Form) return !isPlural ? 'common.form' : 'form.module_name';
    if (objectType === ObjectTypes.UserAccessRequest) return 'user_requests';
    if (objectType === ObjectTypes.Task || objectType === ObjectTypes.Task2)
        return isPlural ? 'task.tasks' : 'task.task';

    if (objectType === ObjectTypes.Checklist2) return isPlural ? 'checklist.checklists_v2' : 'checklist.checklist_v2';
    if (objectType === ObjectTypes.Checklist2Audit)
        return isPlural ? 'checklist.checklists_audit_v2' : 'checklist.checklist_audit_v2';

    if (objectType === ObjectTypes.Checklist2Template)
        return isPlural ? 'templates' : 'checklist.checklist_template_v2';
    if (objectType === ObjectTypes.Checklist2AuditTemplate)
        return isPlural ? 'checklist.checklist_audit_templates_v2' : 'checklist.checklist_audit_template_v2';

    if (objectType === ObjectTypes.ChecklistSchedule)
        return isPlural ? 'checklist.checklist_schedules' : 'checklist.checklist_schedule_v2';
    if (objectType === ObjectTypes.Checklist2AuditSchedule)
        return isPlural ? 'checklist.checklist_schedules_audit_v2' : 'checklist.checklist_schedule_audit_v2';

    if (objectType === ObjectTypes.ChecklistToSchedule) return 'checklist.checklist_v2';
    if (objectType === ObjectTypes.ChecklistToAuditSchedule) return 'checklist.checklist_audit_v2';

    if (objectType === ObjectTypes.Checkpoint2) return 'checklist_checkpoint_v2';
    if (objectType === ObjectTypes.Checkpoint2Audit) return 'checklist_checkpoint_audit_v2';

    if (objectType === ObjectTypes.Checklist2Report) return isPlural ? 'reports' : 'reports';
    if (objectType === ObjectTypes.Checklist2AuditReport)
        return isPlural ? 'checklist.checklist_reports_audit_v2' : 'checklist.checklist_report_audit_v2';

    if (objectType === ObjectTypes.Onboarding) return isPlural ? 'onboarding.onboardings' : 'onboarding.onboarding';
    if (objectType === ObjectTypes.TodoList) return isPlural ? 'onboarding.todo_lists' : 'onboarding.todo_list';
    if (objectType === ObjectTypes.Quiz) return isPlural ? 'onboarding.quizzes' : 'onboarding.quiz';

    return !isPlural ? 'common.item' : 'common.items';
}
